import TryItOutAuthMode from '../../types/TryItOutAuthMode';
import { getAuthModeSelectorAndPath, getSelectedAuthMode } from './dom';
import { HTTP_HEADERS } from './constants';
import type { CachedRequestData, SwaggerUIResponse } from './types';

/**
 * Gets request auth mode and operation path based on auth mode selector
 */
export const getRequestAuthModeAndPath = (
  requestMethod: string,
  requestPath: string,
): { authMode: TryItOutAuthMode; operationPath: string } => {
  const { authModeSelector, operationPath } = getAuthModeSelectorAndPath(
    requestMethod,
    requestPath,
  );

  if (!authModeSelector) {
    return { authMode: TryItOutAuthMode.NONE, operationPath }; // default to no auth
  }

  return {
    authMode: getSelectedAuthMode(authModeSelector),
    operationPath,
  };
};

/**
 * Builds CSRF retry request configuration from cached request data
 */
export const buildCSRFRetryRequestConfig = (
  cachedRequest: CachedRequestData | undefined,
  csrfToken: string,
): RequestInit => {
  return {
    method: cachedRequest?.method || 'GET',
    body: cachedRequest?.body,
    headers: { [HTTP_HEADERS.CSRF_TOKEN]: csrfToken },
    credentials: cachedRequest?.credentials || 'omit',
  };
};

/**
 * Transforms fetch Response to SwaggerUI-compatible response object
 */
export const transformFetchResponse = async (
  fetchResponse: Response,
): Promise<SwaggerUIResponse> => {
  return {
    url: fetchResponse.url,
    status: fetchResponse.status,
    statusText: fetchResponse.statusText,
    ok: fetchResponse.ok,
    headers: fetchResponse.headers,
    text: await fetchResponse.text(),
  };
};
